import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
});

export class EventsFetchAPI {

    static async getEventsByBusiness(business_id, token) {
        let url = `/event?business_id=${business_id}`;
        if (business_id === false) {
            url = `/event`
        }

        const res = await server(url, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async getBranchByEvent(event_id, token) {
        const res = await server(`/branchoffice/by-event?event_id=${event_id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }


     static async getMachinesByEvent(event_date_id, token) {
        const res = await server(`/machines/event?event_date_id=${event_date_id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }




}

